import { render, staticRenderFns } from "./OrderPay.vue?vue&type=template&id=3d1dbc33&"
import script from "./OrderPay.vue?vue&type=script&lang=js&"
export * from "./OrderPay.vue?vue&type=script&lang=js&"
import style0 from "./OrderPay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports